import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useUpdateChannelFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/update-channel.form-validation';
import { UpdateChannelModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/update-channel.model';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const ChargePointChannelUpdateFormStep1QrCodeFragment =
  (): React.JSX.Element => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const { control } =
      useFormContext<
        Pick<UpdateChannelModel, 'chargePointId' | 'channelId' | 'channel'>
      >();
    const { channelQrCode } = useUpdateChannelFormValidation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <Controller
        name="channel.qrCode"
        control={control}
        rules={channelQrCode}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextInput
              label={t('delmonicos-shared-sdk.outputs-channel.qr-code')}
              placeholder={t('delmonicos-shared-sdk.outputs-channel.qr-code')}
              required={!!channelQrCode.required}
              errorMessage={error?.message}
              {...field}
              value={field.value ?? ''}
              onChange={(e) =>
                field.onChange(e.target.value === '' ? '' : e.target.value)
              }
            />
          );
        }}
      />
    );
  };

export const ChargePointChannelUpdateFormStep1Controller =
  (): React.JSX.Element => {
    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <Stack
        direction="row"
        justifyContent="stretch"
        alignItems="stretch"
        flex={1}
        gap={GapEnum.XL}>
        <Stack
          direction="column"
          flex={1}
          alignItems="stretch"
          gap={GapEnum.XL}>
          <ChargePointChannelUpdateFormStep1QrCodeFragment />
        </Stack>
      </Stack>
    );
  };
